import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Button } from '@monavate/ui-core';

const Wrapper = styled.div`
    padding: 40px 40px 80px;
    text-align: center;
`;

const ErrorTitle = styled.div`
    color: ${(props) => props.theme['Content/primary']}
    text-align: center;
    font-family: Poppins;
    font-size: 34px;
    font-style: normal;
    font-weight: 600;
    line-height: 44px;
`;

const ErrorText = styled.div`
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: ${(props) => props.theme['Content/primary']};
    margin-top: 15px;
    margin-bottom: 30px;
`;

const Text500 = styled.div`
    text-align: center;
    color: ${(props) => props.theme['Categorical/10/emphasis']};
    font-family: Poppins;
    font-size: 200px;
    font-style: normal;
    font-weight: 900;
    line-height: 200px;
    letter-spacing: 10px;
`;

const Page500 = (): ReactElement => {
    // the app decides at page load whether to mount Auth0Provider, and this page is
    // public, so homepage needs a full reload to come back with the provider in place
    const homeOnClickHandler = () => window.location.assign('/');

    return (
        <Wrapper>
            <Text500>500</Text500>
            <ErrorTitle>Internal server error</ErrorTitle>
            <ErrorText>
                Try to refresh this page or feel free to contact us in cases <br />
                this error persists.
            </ErrorText>
            <br />
            <Button
                viewType="primary"
                handleClick={homeOnClickHandler}
                dataTestId="button-500-home"
            >
                Return to homepage
            </Button>
        </Wrapper>
    );
};
export default Page500;
